<template>
  <div class="tooltip-container" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <slot></slot>
    <div 
      v-if="isVisible" 
      class="tooltip" 
      :class="{ 'tooltip-visible': isVisible }"
      ref="tooltip"
      v-html="text"
    >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  methods: {
    showTooltip() {
      this.isVisible = true;
      this.$nextTick(() => {
        this.positionTooltip();
      });
    },
    hideTooltip() {
      this.isVisible = false;
    },
    positionTooltip() {
      if (this.$refs.tooltip) {
        const tooltip = this.$refs.tooltip;
        const container = this.$el;
        const rect = container.getBoundingClientRect();
        
        // Позиционируем относительно viewport, а не контейнера
        tooltip.style.position = 'fixed';
        
        let left = rect.right + 10;
        let top = rect.top;
        
        // Проверяем, не выходит ли tooltip за правую границу экрана
        const tooltipWidth = 370; // max-width из CSS
        let showOnLeft = false;
        if (left + tooltipWidth > window.innerWidth) {
          // Показываем слева от элемента
          left = rect.left - tooltipWidth - 10;
          showOnLeft = true;
        }
        
        // Проверяем, не выходит ли tooltip за нижнюю границу экрана
        const tooltipHeight = 100; // примерная высота
        if (top + tooltipHeight > window.innerHeight) {
          top = window.innerHeight - tooltipHeight - 10;
        }
        
        tooltip.style.left = `${left}px`;
        tooltip.style.top = `${top}px`;
        tooltip.style.width = 'auto';
        tooltip.style.maxWidth = '370px';
        
        // Добавляем класс для правильного отображения стрелки
        if (showOnLeft) {
          tooltip.classList.add('tooltip-left');
        } else {
          tooltip.classList.remove('tooltip-left');
        }
      }
    }
  }
}
</script>

<style scoped>
.tooltip-container {
  position: relative;
}

.tooltip {
  position: fixed;
  background-color: #343c47;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  line-height: 1.4;
  max-width: 370px;
  white-space: normal !important;
  word-wrap: break-word !important;
  text-align: left !important;
  z-index: 1000;
  opacity: 0;
  transform: translateX(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.tooltip b {
  font-weight: 600;
}

.tooltip-visible {
  opacity: 1;
  transform: translateX(0);
}

.tooltip::before {
  content: '';
  position: absolute;
  left: -6px;
  top: 50%;
  transform: translateY(-50%);
  border: 6px solid transparent;
  border-right-color: #343c47;
}

.tooltip.tooltip-left::before {
  left: auto;
  right: -6px;
  border-right-color: transparent;
  border-left-color: #343c47;
}
</style>
